import React, { useEffect, memo, useCallback, useState } from "react";
import { Menu, Dropdown } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  MehOutlined,
  FormOutlined,
  LogoutOutlined,
  LoadingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import Icon from "components/util-components/Icon";

import * as moment from "moment";
import { Link } from "react-router-dom";

const menuItem = [
  {
    title: "My Profile",
    icon: UserOutlined,
    path: "/app/my-profile",
  },
  {
    title: "Sign Out",
    icon: LogoutOutlined,
    path: "/auth/login",
    onMenuClick: () => {
      localStorage.clear();
    },
  },
];

export const NavProfile = (props) => {
  const getCurrentTime = () => {
    return moment().format("dddd, DD MMMM YYYY");
  };

  const profileImg = "/img/avatars/thumb-1.jpg";
  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <Link to={el.path} onClick={el.onMenuClick}>
                  <Icon className="mr-3" type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </Link>
              </Menu.Item>
            );
          })}
        </Menu>
      </div>
    </div>
  );
  // re-read after My Profile saves a new name
  const [firstName, setFirstName] = useState(localStorage.getItem("first_name") || "");
  useEffect(() => {
    const refresh = () => setFirstName(localStorage.getItem("first_name") || "");
    window.addEventListener("profile-updated", refresh);
    return () => window.removeEventListener("profile-updated", refresh);
  }, []);

  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <button type="button" className="header-pill">
        <span className="header-pill-avatar">{firstName.charAt(0).toUpperCase()}</span>
        <span className="header-pill-text">
          <span className="header-pill-date">{getCurrentTime()}</span>
          <span className="header-pill-name">Welcome, {firstName}</span>
        </span>
      </button>
    </Dropdown>
  );
};

export default memo(NavProfile);
